export const ROLE_ID = {
  CLIENT: 0,
  COMPANY: 1,
  ADMIN: 2,
};
